import { actionTypes } from '../actions/data';

// DEFAULT STATE
export const initData = {
  weights: [0, 0],
  ytw: 0.0,
  duration: 0.0,
  ytwVS: 0.0,
  durationVS: 0.0,
  data: [],
  fundData: [],
  leftFund: null,
  rightFund: null,
  aggData: null,
};

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DATA:
      const fundData = action.value;
      return Object.assign({}, state, {
        fundData: fundData,
      });
    case actionTypes.LOAD_AGG_INDEX:
      return Object.assign({}, state, {
        aggData: action.value,
      });
    case actionTypes.SET_YTW:
      return Object.assign({}, state, {
        ytw: action.value,
      });
    case actionTypes.SET_DURATION:
      return Object.assign({}, state, {
        duration: action.value,
      });
    case actionTypes.SET_YTW_VS:
      return Object.assign({}, state, {
        ytwVS: action.value,
      });
    case actionTypes.SET_DURATION_VS:
      return Object.assign({}, state, {
        durationVS: action.value,
      });
    case actionTypes.SET_WEIGHTS:
      return Object.assign({}, state, {
        weights: action.value,
      });
    case actionTypes.UPDATE_FUND:
      return Object.assign({}, state, {
        selectedFund: action.value,
      });

    case actionTypes.FILTER_DATA:
      const allData = state.fundData;
      const filtered = getFilteredData(allData, state);
      return Object.assign({}, state, {
        filteredFundData: filtered,
      });
    case actionTypes.UPDATE_SELECTED:

      return Object.assign({}, state, {
        leftFund: action.leftFund,
        rightFund: action.rightFund,
      });
     

    default:
      return state;
  }
};

function getFilteredData(fundData, state) {
  const selectedFund = state.selectedFund;
  const allData = fundData;
  let filtered = '';

  if (selectedFund === 'USFR' && allData) {
    filtered = allData.filter(function (fund) {
      return (fund.ticker !== 'AGZD' && fund.ticker !== 'HYZD');
    });
  } else if (selectedFund === 'AGZD' && allData) {
    filtered = allData.filter(function (fund) {
      return (fund.ticker !== 'USFR' && fund.ticker !== 'HYZD');
    });
  } else if (selectedFund === 'HYZD' && allData) {
    filtered = allData.filter(function (fund) {
      return (fund.ticker !== 'USFR' && fund.ticker !== 'AGZD');
    });
  }

  return filtered;
}

// READS
export const getWeights = (state) => state.data.weights;
export const getData = (state) => state.data.data;
export const getYTW = (state) => state.data.ytw;
export const getDuration = (state) => state.data.duration;
export const getYTWVS = (state) => state.data.ytwVS;
export const getDurationVS = (state) => state.data.durationVS;
export const getFundData = (state) => state.data.fundData;
export const getSelectedFund = (state) => state.data.selectedFund;
export const getFilteredFundData = (state) => state.data.filteredFundData;
export const getLeftFund = (state) => state.data.leftFund;
export const getRightFund = (state) => state.data.rightFund;
export const getAggData = (state) => state.data.aggData;
export default data;
